module.exports = __webpack_public_path__ + "img/markBGI2.aa2df26f.png";